import { DependsOnIfEnum } from "@generation/schema-core/src/client/enums/dependsOnIfEnum";
import { DependsOnThenEnum } from "@generation/schema-core/src/client/enums/dependsOnThenEnum";
import { INestedDependsOn } from "@generation/schema-core/src/client/model/dependsOn";
import { RegelingOptions } from "@klantondersteuning/shared/src/form/interface/SimpleForm/RegelingOptions";
import {
  regelingProp,
  voorWieSteltUDeVraagProp,
  waaroverGaatUwVraagPropWlz,
  waaroverGaatUwVraagPropWmo
} from "../utils/contactFormulierProps";
import { voorMezelfIkBenKlantOptie } from "../utils/voorWieSteltUDeVraagOptions";

export const showVoorWieSteltUEenVraag: INestedDependsOn[] = [
  {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsNotGiven
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsEqualToValue,
        value: RegelingOptions.MedicijnenMeeOpReis
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsEqualToValue,
        value: RegelingOptions.Buitenland
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsEqualToValue,
        value: RegelingOptions.WmoAT
      },
      {
        property: waaroverGaatUwVraagPropWmo,
        if: DependsOnIfEnum.IsNotGiven
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsEqualToValue,
        value: RegelingOptions.Wlz
      },
      {
        property: waaroverGaatUwVraagPropWlz,
        if: DependsOnIfEnum.IsNotGiven
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

export const hideWhenVoorWieSteltUEenVraagIsShownAndEmptyOrNotVraagVoorMezelfEnIkBenKlant: INestedDependsOn[] =
  [
    createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(RegelingOptions.Wlz),
    createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(RegelingOptions.WmoAT),
    createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(RegelingOptions.BeschermdWonen),
    createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(RegelingOptions.Gemoedsbezwaarden),
    createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(RegelingOptions.Onverzekerden),
    createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(
      RegelingOptions.BetalingsachterstandZorgpremie
    ),
    createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(RegelingOptions.Onbekend)
  ];

function createNestedDependsOnRegelingWithVoorWieSteltUEenVraagKeuze(
  regeling: RegelingOptions
): INestedDependsOn {
  return {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsEqualToValue,
        value: regeling
      },
      {
        property: voorWieSteltUDeVraagProp,
        if: DependsOnIfEnum.IsNotEqualToValue,
        value: voorMezelfIkBenKlantOptie
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  };
}
